// @flow
import {
  call,
  put,
  takeEvery,
}                                                from 'redux-saga/effects';
import type { DeleteRequestActionAfterDispatch } from '../../actions/apiResourceActions';
import {
  deleteApiResourceFailure,
  deleteApiResourceRequest,
  deleteApiResourceSuccess,
}                                                from '../../actions/apiResourceActions';
import { METHOD_DEL }                            from '../../actions/utils/apiResources/apiResourceActions.const';
import Raven                                     from '../../modules/raven-cdn';
import API                                       from '../../services/API';


function* handleApiDeleteRequests(): Generator<void, void, void> {

  yield takeEvery(deleteApiResourceRequest, deleteApiResource);

}


/**
 *
 * @param {{uuid: Identifier, resourceIRI: string, method: string, dataToSave: object}} action
 *
 * @return {IterableIterator<*>}
 */
function* deleteApiResource(action: DeleteRequestActionAfterDispatch) {

  const {payload: {resourceIRI}} = action;

  const callYield = call(API.delete, resourceIRI, METHOD_DEL);

  const nextActionCommonArgs = {...action.payload, ...action.meta};

  try {

    yield callYield;

    const successAction = deleteApiResourceSuccess(nextActionCommonArgs);

    yield put(successAction);

  } catch (error) {

    Raven.captureException(error);

    const failureAction = deleteApiResourceFailure(error, nextActionCommonArgs);

    yield put(failureAction);

  }

}


export default handleApiDeleteRequests;



// WEBPACK FOOTER //
// ./src/sagas/resources/handleApiDeleteRequests.js